import { showError, hideError } from "./errors";
import { validateInputs } from "./validate";
import {
  hideContactForm,
  setLoadingState,
  showSuccessMessage,
} from "./styles";
import sendFeedback from "./sendFeedback";

const emailInput = document.getElementById("email");
const firstNameInput = document.getElementById("name");
const messageInput = document.getElementById("message");

function validateForm({ event, validateCaptcha = () => {} }) {
  event.preventDefault();

  const isValid = validateInputs();

  if (isValid) {
    setLoadingState(true);
    validateCaptcha();
  }
}

/**
 * Обрабатываем отправку формы.
 */
async function handleSubmitContactUsForm() {
  try {
    const response = await sendFeedback({
      name: firstNameInput.value,
      email: emailInput.value,
      message: messageInput.value,
    });

    if (response.ok) {
      hideContactForm();
      showSuccessMessage();
    } else {
      showError("message-errors", "Ошибка при отправке сообщения.");
      setLoadingState(false);
      setTimeout(() => {
        hideError("message-errors");
      }, 3000);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (e) {
    showError("message-errors", "Произошла ошибка. Попробуйте еще раз");
    setLoadingState(false);
  }
}

export { validateForm, handleSubmitContactUsForm };
